// extracted by mini-css-extract-plugin
export default {"loader":"CircularSpinner_loader__+9Oqj","rotation":"CircularSpinner_rotation__eOWWW"};